export default {
  name: 'chatmsg_menu_actions',
  components:{
  },  
  props:['propsSelectedChatMsgForAction'],
  data () {
    return {
      selectedChatMsgForAction: this.propsSelectedChatMsgForAction,
      message_type: this.propsSelectedChatMsgForAction.message_type,
      participant_is_admin: this.propsSelectedChatMsgForAction.participant_is_admin,
      showChatMsgActionMenu: this.propsSelectedChatMsgForAction.showChatMsgActionMenu,
      text_to_copy: this.propsSelectedChatMsgForAction.text_msg,
      userData: this.propsSelectedChatMsgForAction.userData,

      showDoReply:this.propsSelectedChatMsgForAction.showDoReply,
      showGotoMessage:this.propsSelectedChatMsgForAction.showGotoMessage,
      showCopyMessage:this.propsSelectedChatMsgForAction.showCopyMessage,
      showForwardMessage:this.propsSelectedChatMsgForAction.showForwardMessage,
      showReportIssue:this.propsSelectedChatMsgForAction.showReportIssue,
      showPinnedMessage:this.propsSelectedChatMsgForAction.showPinnedMessage,
      showUnPinnedMessage:this.propsSelectedChatMsgForAction.showUnPinnedMessage,
      showDeleteMessage:this.propsSelectedChatMsgForAction.showDeleteMessage,
    }
  },
  updated() {
  },
  created() {
  },
  async mounted() {
  },
  computed: {
  },
  methods: {
    /**
     * chatmsgActionReply
     */  
    chatmsgActionReply(){
      this.$emit('emit_chatmsgActionReply');
    },
    /**
     * chatmsgActionDelete
     */  
    chatmsgActionDelete(){
      this.$emit('emit_chatmsgActionDelete');
    },
    /**
     * chatmsgActionPinMessage
     */  
    chatmsgActionPinMessage(message_type){
      this.$emit('emit_chatmsgActionPinMessage', message_type);
    },
    /**
     * chatmsgActionUnPinMessage
     */  
    chatmsgActionUnPinMessage(message_type){
      this.$emit('emit_chatmsgActionUnPinMessage', message_type);
    },

    /**
     * chatmsgActionGotoMessage
     */  
    chatmsgActionGotoMessage(){
      this.$emit('emit_chatmsgActionGotoMessage');
    },
    /**
     * chatmsgActionForwardMessage
     */  
    chatmsgActionForwardMessage(){
      this.$emit('emit_chatmsgActionForwardMessage');
    },
    /**
     * chatmsgActionCopyMessage
     */  
    chatmsgActionCopyMessage(){
      this.$emit('emit_chatmsgActionCopyMessage');
    },
    /**
     * chatmsgActionReportIssue
     */  
    chatmsgActionReportIssue(){
      this.$emit('emit_chatmsgActionReportIssue');
    },          
  },//methods End
  watch: {
    showChatMsgActionMenu: function () {      
      this.$emit('emitUpdateShowMsgActionsState', this.showChatMsgActionMenu);
    },
  },
}
